import { connect } from 'react-redux';
import qs from 'query-string';
import toMomentObject from 'react-dates/lib/utils/toMomentObject';
import toISODateString from 'react-dates/lib/utils/toISODateString';
import isUndefined from 'lodash/isUndefined';
import { queryChange, fetchListings } from 'listing/listing.actions';
import { getNumberOfMonthsInDatePicker } from 'website/website.selectors';
import SearchForm from 'components/SearchForm';
import { push } from 'react-router-redux';

function mapStateToProps(state) {
  if (!state.listings.query) return {};

  return {
    city: state.listings.query.city,
    startDate: toMomentObject(state.listings.query.startDate),
    endDate: toMomentObject(state.listings.query.endDate),
    guests: state.listings.query.guests,
    cities: state.cities,
    maxGuests: state.website.maxGuests,
    color: state.website.color,
    numberOfMonths: getNumberOfMonthsInDatePicker(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onCityChange: city => dispatch(queryChange({ city: city })),
    onDateChange: ({ startDate, endDate }) => {
      const dates = {};
      if (!isUndefined(startDate)) dates.startDate = toISODateString(startDate);
      if (!isUndefined(endDate)) dates.endDate = toISODateString(endDate);
      dispatch(queryChange(dates));
    },
    onGuestChange: guests => dispatch(queryChange({ guests: guests.value })),
    onSearch: query => {
      if (query.startDate) query.startDate = toISODateString(query.startDate);
      if (query.endDate) query.endDate = toISODateString(query.endDate);
      return dispatch(fetchListings({ ...query, isSearch: true }))
        .then(() => dispatch(push(`/listings?${qs.stringify(query)}`)));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchForm);


// WEBPACK FOOTER //
// ./src/containers/SearchForm.container.js